import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import FooterWeb from 'components/organisms/FooterWeb';
import HeaderWeb from 'components/organisms/HeaderWeb';
import HelmetComponent from 'pages/HelmetComponent';
import { getAccessToken } from 'services/common/storage';
import { RootState } from 'store';
import { getProfileAction } from 'store/auth';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { getSystemAction } from 'store/system';

const WebsiteLayout: React.FC = () => {
  const dispatch = useAppDispatch();
  const systemOthers = useAppSelector((state: RootState) => state.system.system);

  useEffect(() => {
    dispatch(getSystemAction());
    const token = getAccessToken();
    if (token) {
      dispatch(getProfileAction()).unwrap().finally(() => {
      });
    }
  }, [dispatch]);
  return (
    <main className="website-layout">
      <HelmetComponent />
      <HeaderWeb
        menu={[
          { label: 'Home', href: '/' },
          { label: 'Pricing', href: '/pricing' },
          // { label: 'Help Center', href: '/help-center' },
          { label: 'Blog', href: `/${systemOthers?.slugPages?.blog || '404'}` },
        ]}
      />
      <div className="website-layout_body">
        <Outlet />
      </div>
      <FooterWeb />
    </main>
  );
};

export default WebsiteLayout;
